(function($){
  $(document).ready(function() {

    const siteheader = $("body:not(.admin) #site-header");
    let menuOffset = siteheader.outerHeight() + 100;

    let duration = 500;
    if ($('body').hasClass('admin')) {
        const adminPanelHeight = $(".adminPanel").outerHeight();
        duration = 0;
        menuOffset = adminPanelHeight + 30;
        $(':root').css('--adminpanel-height', adminPanelHeight+'px');
    }
    $.localScroll({
        duration: duration,
        hash: true,
        offset: -menuOffset,
    });
    $.extend($.scrollTo.defaults, {
      axis: 'y',
      duration: 200,
      offset: -menuOffset,
    });

    $('[data-js="no-link"]').on('click', function(e){
        e.preventDefault();
    })

    $('.menu_link').on('focus', function(){
        $(this).parent().addClass('hover').siblings().removeClass('hover');
    })

    $('.menu_item, .outil-item').on('mouseover', function(){
        $(this).addClass('hover').siblings().removeClass('hover');
    });
    $('.menu_item, .outil-item').on('mouseout', function(){
        $(this).removeClass('hover');
    });

    $('body').on('click', '.show_submenu', function(e){
        e.preventDefault();
        $(this).delay(150).parent().toggleClass('open').siblings().removeClass('open');
        const submenu = $(this).siblings('.submenu');
        submenu.attr('aria-hidden', submenu.is('[aria-hidden=true]') ? false : true);
        submenu.attr('aria-expanded', submenu.is('[aria-expanded=true]') ? false : true);
    });


    $('<div class="modal" tabindex="1">').appendTo('body');
    var modal = $('.modal');

    $('.modal').on('click', function(){
        close_all();
    });



    var masque = $('<div class="masque" tabindex="1">').appendTo('body');
    masque.on('click', function(){
        close_all();
    });

    var menuToggle = $('#site-menu-toggle'),
        menu = $(menuToggle.data('target'));

    menuToggle.click(function(e) {
        e.preventDefault();
        modal.toggle();
        // masque.toggle();
        menuToggle.toggleClass('is-active');
        menuToggle.attr('aria-pressed', menuToggle.is('[aria-pressed=true]') ? false : true);
        menu.toggleClass('open');
        // menu.find('.nav1').toggleClass('open');
        // menu.find('.current').addClass('open');
        $('body').css('--z-header', menu.hasClass('open') ? '1007' : '');
    });

    function close_all() {
        $('#site-recherche').removeClass('open');
        // $('.menu-recherche').removeClass('open');
        masque.hide();
        menu.removeClass('open');
        $('.menu_item.hover').removeClass('hover');
        menuToggle.removeClass('is-active');
        $('body').css('--z-header', '');
        fermer_popin();
    }

    var keys={'esc': 27, 'left': 37, 'right': 39}
    $(document).on("keydown", function(e) {
        switch(e.keyCode){
            case keys.esc:
                e.preventDefault();
                close_all();
            break;
        }
    });


    // const menu_item_with_submenu = $('.nav:not(.nav-themes-travail) .menu_item.has_submenu');

    // menu_item_with_submenu.on('mouseover', function(){
    //     const submenu = $(this).find('.submenu');
    //     submenu.attr('aria-hidden', 'false');
    //     submenu.attr('aria-expanded', 'true');
    // });
    // menu_item_with_submenu.on('mouseout', function(){
    //     const submenu = $(this).find('.submenu');
    //     submenu.attr('aria-hidden', 'true');
    //     submenu.attr('aria-expanded', 'false');
    // });

    $('.nav-themes-travail .niv1 > .menu_item > .menu_link').on('click', function(e){
        e.preventDefault();
        const submenu = $(this).siblings('.submenu');
        submenu.attr('aria-hidden', submenu.is('[aria-hidden=true]') ? false : true);
        submenu.attr('aria-expanded', submenu.is('[aria-expanded=true]') ? false : true);
        $(this).parent().toggleClass('toggled').siblings().removeClass('toggled');
    });

  })
})(jQuery);

function fermer_popin(){
    $("#popin").html("");
    $("#popin").hide();
    $("#contpopinnoir").html("");
    $("#popinnoir").hide();
    $("#minipopin .container").html("");
    $("#minipopin").hide();
}

function ouvre_popin(data){
    $("#popin .container").html(data); // ON AFFICHE LA REPONSE
    $("#popin").show();

    var left = ($(window).width() - $("#popin").width())/2;
    var posScroll = parseInt($(document).scrollTop());

    $("#popin").css('top',(posScroll+150)+'px');
    $("#popin").css('left',left+'px');

    $('.tableauborder tbody').each(function(){
        $('tr:has(td):odd', this).addClass('trgris');
    });
}

function ouvre_minipopin(data){
    $("#minipopin .container").html(data); // ON AFFICHE LA REPONSE
    $("#minipopin").show();
}

function ouvre_popin_responsive(data){
    $("#popin .container").html(data); // ON AFFICHE LA REPONSE
    $("#popin").show();

    // var left = ($(window).width() - $("#popin").width())/2;
    var posScroll = parseInt($(document).scrollTop());

    $("#popin").css('top',(posScroll+150)+'px');
}
